/* eslint-disable guard-for-in */
export function convertToCSV (objArray) {
  const array = !Array.isArray(objArray) ? JSON.parse(objArray) : objArray
  let str = ''

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < array.length; i++) {
    let line = ''
    // eslint-disable-next-line no-restricted-syntax
    for (const index in array[i]) {
      if (line !== '') line += ','
      line += array[i][index]
    }
    str += `${line}\r\n`
  }
  return str
}

export function exportCSVFile (headers, items, fileTitle) {
  if (headers) {
    items.unshift(headers)
  }
  const jsonObject = JSON.stringify(items)

  const csv = convertToCSV(jsonObject)

  const exportedFilenmae = `${fileTitle}.csv` || 'export.csv'

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFilenmae)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
